import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import {
  Card,
  Flex,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  SimpleGrid,
  Spacer,
  Text,
} from "@chakra-ui/react";
import { FiChevronLeft, FiChevronRight, FiSearch } from "react-icons/fi";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DisplayData from "../../components/DisplayData";
import { get_vehicle_list } from "../../redux/vehiclSlice";
import CustomButton from "../../components/CustomButton";

const VehicleList = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState(5);
  const [page, setpage] = useState(1);
  const [initialValue, setInitialValue] = useState(1);
  const { vehicle_list, total_vehicle_count } = useSelector(
    (state) => state.vehicles
  );

  useEffect(() => {
    store.dispatch(get_vehicle_list({ page: page, rows: rows }));
  }, []);
  const onPrevious = () => {
    initialValue == 1 || setInitialValue(Number(initialValue) - Number(rows));
    page == 1 || setpage(page - 1);
    page === 1 ||
      store.dispatch(get_vehicle_list({ page: page - 1, rows: rows }));
  };

  const onNext = () => {
    rows * page >= total_vehicle_count ||
      setInitialValue(Number(initialValue) + Number(rows));
    rows * page >= total_vehicle_count || setpage(page + 1);
    rows * page >= total_vehicle_count ||
      store.dispatch(get_vehicle_list({ page: page + 1, rows: rows }));
  };
  // vehicle / add - vehicle;
  return (
    <>
    <Card
  display="flex"
  flexDirection={["column", "row"]}
  alignItems={["flex-start", "center"]}
  justifyContent="space-between"
  paddingInline={5}
  paddingBlock={2}
  gap={3}
  flexWrap="wrap"
>
  <Heading fontSize="xl">Vehicle List</Heading>
  <CustomButton
    title="Add Vehicle"
    onClick={() => navigate("/vehicle-list/add-vehicle")}
    w={["100%", "auto"]} // Full width button on mobile
  />
</Card>

<Card
  bg="#fff"
  paddingInline={5}
  paddingBlock={2}
  flexDirection={["column", "row"]}
  alignItems={["flex-start", "center"]}
  gap={3}
  flexWrap="wrap"
>
  <Flex align="center" gap={2} w={["100%", "auto"]}>
    <Select
      placeholder=""
      size="md"
      value={rows}
      onChange={(e) => {
        store.dispatch(get_vehicle_list({ page: page, rows: e.target.value }));
        setRows(e.target.value);
      }}
      w={["100%", "80px"]}
    >
      <option value="5">5</option>
      <option value="10">10</option>
      <option value="25">25</option>
      <option value="50">50</option>
      <option value="100">100</option>
    </Select>
  </Flex>

  <InputGroup
    bg="#f4f5f7"
    borderRadius={5}
    maxW="sm"
    w={["100%", "auto"]}
  >
    <Input placeholder="Search..." />
    <InputRightElement>
      <FiSearch />
    </InputRightElement>
  </InputGroup>
</Card>

      <SimpleGrid minChildWidth="xs" spacing="10px">
        {vehicle_list.map((el, i) => (
          <Card
            key={i}
            paddingInline={5}
            paddingBlock={2}
            cursor={"pointer"}
            onClick={() =>
              navigate("/vehicle-list/vehicle-detail", { state: el.id })
            }
          >
            <Flex justify={"space-between"}>
              <DisplayData
                fs={"16px"}
                v_color={"#007bc9"}
                fw={"bold"}
                value={el.vehicleno || "NA"}
              />
              <DisplayData v_color={"#f37022"} fw={"bold"} value={el.type || "NA"} />
            </Flex>

            <DisplayData title={"Make"} value={el.make || "NA"} />
            <DisplayData title={"Chassis No."} value={el.chassis || "NA"} />
            <DisplayData title={"Capacity"} value={el.capacity || "NA"} />
          </Card>
        ))}
      </SimpleGrid>
      <Card
        alignItems={"center"}
        alignSelf={"end"}
        gap={3}
        flexDirection={"row"}
      >
        <FiChevronLeft
          cursor={"pointer"}
          color={page == 1 ? "gray" : "#007bc9"}
          size={35}
          onClick={onPrevious}
        />
        <Flex gap={3}>
          <Text>{initialValue}</Text>-
          <Text>
            {rows * page >= total_vehicle_count
              ? total_vehicle_count
              : rows * page}
          </Text>
          <Text>of</Text>
          <Text>{total_vehicle_count}</Text>
        </Flex>
        <FiChevronRight
          cursor={"pointer"}
          color={rows * page >= total_vehicle_count ? "gray" : "#007bc9"}
          size={35}
          onClick={onNext}
        />
      </Card>
    </>
  );
};

export default VehicleList;
